// eslint-disable-next-line no-restricted-imports
import posthog, { type Properties } from 'posthog-js';
// eslint-disable-next-line no-restricted-imports
import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

import { type EventAction, type EventCategory } from './types';

/**
 * Non-hook version for use in non-React code (e.g., agent classes).
 * Uses the same event naming convention as useCaptureEvents.
 */
export function captureEvent(args: {
  category: EventCategory;
  action: EventAction;
  properties?: Properties;
}): void {
  const { category, action, properties } = args;
  posthog.capture(`${category}:${action}`, properties);
}

export function useCaptureEvents() {
  const posthog = usePostHog();

  /**
   * Adhere to the PostHog suggested event naming format of `<category>:<resource>-<action>` for consistency.
   * We'll use UpperCamelCase to follow internal enum naming standards.
   *
   * https://posthog.com/docs/product-analytics/best-practices#suggested-naming-guide
   *  */
  const captureEvent = useCallback(
    (args: { category: EventCategory; action: EventAction; properties?: Properties }) => {
      const { category, action, properties } = args;
      return posthog.capture(`${category}:${action}`, properties);
    },
    [posthog]
  );

  return {
    captureEvent,
  };
}
